import React from "react";
import { Footer } from "../../components";

const Terms: React.FC = () => {
  return (
    <div className="bg-green-900 min-h-screen text-white flex flex-col font-sans">
      <section className="py-16 px-6 md:px-16 text-center bg-green-800">
        <h1 className="text-4xl md:text-6xl font-extrabold text-yellow-400">Conditions d’Utilisation</h1>
        <p className="mt-4 text-lg text-gray-200 max-w-3xl mx-auto">
          Dernière mise à jour : {new Date().getFullYear()}
        </p>
      </section>

      <section className="flex-grow px-6 md:px-16 py-10 space-y-10 text-gray-100">

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">1. Objet</h2>
          <p>
            Ces conditions encadrent l’utilisation de l’application Mediiq opérée par 
            <strong> Loven Software Development SARL U</strong>.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">2. Nature du service</h2>
          <p>
            Mediiq est une plateforme de mise en relation entre utilisateurs et 
            <strong>pharmacies partenaires indépendantes</strong>.
            <br />
            Mediiq n’est pas une pharmacie, ne délivre pas de médicaments et 
            ne propose aucun service médical.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">3. Responsabilité</h2>
          <p>
            Les pharmacies sont exclusivement responsables :
          </p>
          <ul className="list-disc ml-6 mt-2">
            <li>De la vérification et préparation des ordonnances</li>
            <li>De la conformité des produits vendus</li>
            <li>De la livraison lorsqu’elle est proposée</li>
          </ul>

          <p className="mt-2">
            Mediiq ne peut être tenu responsable des actes de ces partenaires.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">4. Compte utilisateur</h2>
          <ul className="list-disc ml-6">
            <li>Vous devez fournir des informations exactes</li>
            <li>Vous êtes responsable de la confidentialité de votre compte</li>
            <li>Vous devez utiliser l’application de manière légale</li>
          </ul>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">5. Paiements</h2>
          <p>
            Les paiements sont traités via des partenaires sécurisés.
            Mediiq ne stocke pas les données complètes de cartes bancaires.
          </p>
        </div>

        <div>
          <h2 className="text-2xl font-bold text-green-300 mb-2">6. Suppression du compte</h2>
          <p>
            Vous pouvez demander la suppression de votre compte à tout moment 
            en écrivant à :
            <a href="mailto:support@mediiq.app" className="text-yellow-300 underline ml-1">
              support@mediiq.app
            </a>
          </p>
        </div>

      </section>

      <Footer />
    </div>
  );
};

export default Terms;
